/**
 * @file Scroll to top button.
 */

import React from 'react';
import PropTypes from 'prop-types';
import ScrollUp from 'react-scroll-up';

import Button from './Button';
import ArrowLeft from '../icons/ArrowLeft';

const propTypes = {
  showUnder: PropTypes.number,
  duration: PropTypes.number,
};

const ScrollToTopButton = ({ showUnder = 150, duration, ...props }) => (
  <ScrollUp showUnder={showUnder} duration={duration} {...props}>
    <Button btnStyle="reset" className="scroll-top-btn">
      <ArrowLeft color="#0f84fe" className="scroll-top-arrow" />
    </Button>
  </ScrollUp>
);

ScrollToTopButton.propTypes = propTypes;

export default ScrollToTopButton;
